<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="primary" class="text-capitalize font-weight-bold"> <v-icon>mdi-cog-outline</v-icon>&nbsp; Settings </v-btn>
      </template>
      <v-card class="pa-3" color="pop_bg">
        <v-card-title>
          <span class=" dark--text tw-font-semibold"> Customer Referral Settings</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="light--text" text @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-form class="pa-sm-8 mt-n6" @submit="updatePushNotification()" v-model="valid" ref="form">
          <div class=" tw-flex tw-gap-12 tw-items-center tw-justify-between tw-w-full">
            <div class=" tw-w-1/2">
              <h4 class=" tw-text-base tw-font-semibold dark--text">Referral - Give %</h4>
              <p class=" tw-text-sm">Percentage of purchase amount given to the referrer</p>
            </div>
            <div class=" tw-w-1/2">
              <v-text-field
                class=""
                label="Percentage"
                v-model="percentageGive"
                type="number"
                dense
                min="0"
                append-icon="mdi-percent"
                :rules="[requiredValidator('customer referral percentage')]"
                solo
              >
              </v-text-field>
            </div>
          </div>

          <div class=" tw-flex tw-gap-12 tw-items-center tw-justify-between tw-w-full">
            <div class=" tw-w-1/2">
              <h4 class=" tw-text-base tw-font-semibold dark--text">Referral - Give Max Amount</h4>
              <p class=" tw-text-sm">Percentage of purchase amount given to the referrer</p>
            </div>
            <div class=" tw-w-1/2">
              <v-text-field label="Max. Referral Amount" v-model="maxReferralAmountGive" :rules="[requiredValidator('max. referral amount')]" type="number" dense min="0" solo>
                <template v-slot:append>
                  <h4 class="mt-1 grey--text">KD</h4>
                </template>
              </v-text-field>
            </div>
          </div>

          <div class=" tw-flex tw-gap-12 tw-items-center tw-justify-between tw-w-full">
            <div class=" tw-w-1/2">
              <h4 class=" tw-text-base tw-font-semibold dark--text">Referral - Get %</h4>
              <p class=" tw-text-sm">Percentage of purchase amount get to the referrer</p>
            </div>
            <div class=" tw-w-1/2">
              <v-text-field class="" label="Percentage" v-model="percentage" type="number" dense min="0" append-icon="mdi-percent" :rules="[requiredValidator('customer referral percentage')]" solo>
              </v-text-field>
            </div>
          </div>

          <div class=" tw-flex tw-gap-12 tw-items-center tw-justify-between tw-w-full">
            <div class=" tw-w-1/2">
              <h4 class=" tw-text-base tw-font-semibold dark--text">Referral - Get Max Amount</h4>
              <p class=" tw-text-sm">Percentage of purchase amount get to the referrer</p>
            </div>
            <div class=" tw-w-1/2">
              <v-text-field label="Max. Referral Amount" v-model="maxReferralAmount" :rules="[requiredValidator('max. referral amount')]" type="number" dense min="0" solo>
                <template v-slot:append>
                  <h4 class="mt-1 grey--text">KD</h4>
                </template>
              </v-text-field>
            </div>
          </div>

          <div class=" tw-flex tw-gap-12 tw-items-center tw-justify-between tw-w-full">
            <div class=" tw-w-1/2">
              <h4 class=" tw-text-base tw-font-semibold dark--text">Redeem %</h4>
              <p class=" tw-text-sm">Maximum percentage that can be redeemed</p>
            </div>
            <div class=" tw-w-1/2">
              <v-text-field label="Maximum Redeem percent" v-model="maxRedeemPercent" type="number" dense min="0" append-icon="mdi-percent" :rules="[requiredValidator('Maximum redeem percent')]" solo>
              </v-text-field>
            </div>
          </div>

          <div class=" tw-flex tw-gap-12 tw-items-center tw-justify-between tw-w-full">
            <div class=" tw-w-1/2">
              <h4 class=" tw-text-base tw-font-semibold dark--text">Redeem Max Amount</h4>
              <p class=" tw-text-sm">Maximum amount that can be redeemed</p>
            </div>
            <div class=" tw-w-1/2">
              <v-text-field label="Maximum Redeem amount" v-model="maxRedeemAmount" type="number" dense min="0" append-icon="mdi-percent" :rules="[requiredValidator('Maximum redeem amount')]" solo>
                <template v-slot:append>
                  <h4 class="mt-1 grey--text">KD</h4>
                </template>
              </v-text-field>
            </div>
          </div>
          <div class=" tw-flex tw-justify-center">
            <v-btn
              color="primary"
              :width="$vuetify.breakpoint.smAndUp ? 120 : 100"
              class=" text-capitalize light--text font-weight-bold"
              :loading="btnConfigloading"
              :disabled="!valid"
              @click="updateConfigurations"
              >Update</v-btn
            >
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top :color="snackbarColor">{{ text }}</v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";
export default {
  components: {},
  data() {
    return {
      requiredValidator: requiredValidator,
      maxRedeemAmount: "",
      maxRedeemPercent: "",
      percentageGive: "",
      maxReferralAmountGive: "",
      btnConfigloading: false,
      maxReferralAmount: 0,
      percentage: 0,
      snackbarColor: "success",
      successAlert: false,
      snackbar: false,
      text: "",
      valid: true,
      dialog: false,
      configs: {},
    };
  },
  apollo: {
    getAppConfigurations() {
      return {
        query: require("@/settings/api/getAppConfigurations.graphql"),
        result({ data }) {
          if (data.getAppConfigurations) {
            this.configs = data.getAppConfigurations;
            this.maxReferralAmount = data.getAppConfigurations.customerReferralPercent.maxReferralAmount;
            this.percentage = data.getAppConfigurations.customerReferralPercent.percentage;
            this.maxRedeemPercent = data.getAppConfigurations.customerReferralPercent.maxRedeemPercent;
            this.maxRedeemAmount = data.getAppConfigurations.customerReferralPercent.maxRedeemAmount;
            this.percentageGive = data.getAppConfigurations.customerReferralPercent.percentageGive;
            this.maxReferralAmountGive = data.getAppConfigurations.customerReferralPercent.maxReferralAmountGive;
          }
        },
      };
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    updateConfigurations() {
      this.btnConfigloading = true;
      let customerReferralPercent = {
        maxReferralAmount: parseFloat(this.maxReferralAmount),
        percentage: parseFloat(this.percentage),
        maxRedeemPercent: parseFloat(this.maxRedeemPercent),
        maxRedeemAmount: parseFloat(this.maxRedeemAmount),
        percentageGive: parseFloat(this.percentageGive),
        maxReferralAmountGive: parseFloat(this.maxReferralAmountGive),
      };
      this.$apollo
        .mutate({
          mutation: require("@/settings/api/updateConfigurations.graphql"),
          variables: {
            whatsappNumber: this.configs.whatsappNumber,
            whatsappMessage: this.configs.whatsappMessage,
            customerReferralPercent: customerReferralPercent,
          },
        })
        .then(() => {
          this.text = "Referral Settings successfully updated";
          this.snackbar = true;
          this.btnConfigloading = false;
          this.snackbarColor = "success";
          this.dialog = false;
        })
        .catch(error => {
          if (error.graphQLErrors[0] != null) {
            this.text = error.graphQLErrors[0].message;
            this.snackbarColor = "error";
            this.snackbar = true;
          }
          this.btnConfigloading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style>
.update_btn {
  border: 2px solid #f8166c;
}
</style>
